import React from 'react'

function PageTitle(props){
  return(
    <h2 className={['page-title ' + props.className || ' ']}>{props.title}</h2>
  );
}

export default PageTitle;